import { Component } from '@angular/core';
import {
  ImportLabelsFromCsvResult,
  MigrationService,
  SetFunctionalLocationFromCsvResult,
} from '../../../services/migration.service';

@Component({
  selector: 'app-migration-import',
  templateUrl: './migration-import.component.html',
  styleUrl: './migration-import.component.scss',
  standalone: false,
})
export class MigrationImportComponent {
  // Functional location CSV
  functionalLocationFile: File | null = null;
  isFunctionalLocationImporting = false;
  functionalLocationResult: SetFunctionalLocationFromCsvResult | null = null;
  functionalLocationError: string | null = null;

  // Labels CSV
  labelsFile: File | null = null;
  isLabelsImporting = false;
  labelsResult: ImportLabelsFromCsvResult | null = null;
  labelsError: string | null = null;

  constructor(private migrationService: MigrationService) {}

  onFunctionalLocationFileSelected(event: any): void {
    const files: File[] = event.currentFiles ?? [];
    if (files.length > 0) {
      this.functionalLocationFile = files[0];
      this.functionalLocationResult = null;
      this.functionalLocationError = null;
    }
  }

  onImportFunctionalLocation(): void {
    if (!this.functionalLocationFile) return;

    this.isFunctionalLocationImporting = true;
    this.functionalLocationResult = null;
    this.functionalLocationError = null;

    this.migrationService
      .setRuleFunctionalLocationFromCsv(this.functionalLocationFile)
      .subscribe({
        next: (result) => {
          this.functionalLocationResult = result;
          this.isFunctionalLocationImporting = false;
        },
        error: (err) => {
          this.functionalLocationError =
            err?.message ?? "Une erreur est survenue lors de l'importation.";
          this.isFunctionalLocationImporting = false;
        },
      });
  }

  onLabelsFileSelected(event: any): void {
    const files: File[] = event.currentFiles ?? [];
    if (files.length > 0) {
      this.labelsFile = files[0];
      this.labelsResult = null;
      this.labelsError = null;
    }
  }

  onImportLabels(): void {
    if (!this.labelsFile) return;

    this.isLabelsImporting = true;
    this.labelsResult = null;
    this.labelsError = null;

    this.migrationService.importLabelsFromCsv(this.labelsFile).subscribe({
      next: (result) => {
        this.labelsResult = result;
        this.isLabelsImporting = false;
      },
      error: (err) => {
        this.labelsError =
          err?.message ?? "Une erreur est survenue lors de l'importation.";
        this.isLabelsImporting = false;
      },
    });
  }
}
